import { render, staticRenderFns } from "./ProductRecycle.vue?vue&type=template&id=428d2bfe"
import script from "./ProductRecycle.vue?vue&type=script&lang=js"
export * from "./ProductRecycle.vue?vue&type=script&lang=js"
import style0 from "./ProductRecycle.vue?vue&type=style&index=0&id=428d2bfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports